import React from "react";
import "./Contactus.css"; // Import the CSS file for Contact Us[41]

const ContactUs = () => (
  <section id="contact-us" className="contact-us">
    <h2>Contact Us</h2>
    <form>
      <label>Name:</label>
      <input type="text" placeholder="Enter your name" />

      <label>Email:</label>
      <input type="email" placeholder="Enter your email" />

      <label>Message:</label>
      <textarea placeholder="Enter your message"></textarea>

      <button type="submit" className="send-message-button">Send Message</button>
    </form>
  </section>
);

export default ContactUs;